import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from 'src/app/Services/api.service';
import { UserData } from 'src/app/Services/data.model';

@Injectable({
  providedIn: 'root'
})
export class COEApiService {

  browserDomain: string = this.service.browserDomain;
  constructor(private http: HttpClient, private service: ApiService) { }

  URLAddress(address) {
    const FinalURL = this.service.URLAddress(address, 'coe')
    return FinalURL;
  }

  viewStudentMaster(entityId, session): Observable<UserData>{
    return this.http.get<UserData>(this.URLAddress('/view/studentMaster?entity='+entityId+ '&session='+ session))
  }

  // COE Master API Methods
  viewCOEMaster(entityId, session): Observable<UserData> {
    return this.http.get<UserData>(this.URLAddress('/view/coeMaster?entity=' + entityId + '&session=' + session));
  }

  editCOEMaster(formData): Observable<UserData> {
    return this.http.post<UserData>(this.URLAddress('/edit/coeMaster'), formData);
  }

  // Exam Calendar API Methods
  listExamCalendar(entity, session): Observable<any> {
    // return this.http.get<any>(this.URLAddress('/list/examCalendar?entity=' + entity + '&session=' + session));
    return this.http.get<any>(this.URLAddress('/list/examCalendar?entity=' + entity));

  }

  addExamCalendar(formData): Observable<any> {
    return this.http.post<any>(this.URLAddress('/add/examCalendar'), formData);
  }

  viewExamCalendar(id): Observable<any> {
    return this.http.get<any>(this.URLAddress('/view/examCalendar?id=' + id));
  }

  editExamCalendar(formData): Observable<any> {
    return this.http.post<any>(this.URLAddress('/edit/examCalendar'), formData);
  }

  deleteExamCalendar(id): Observable<any> {
    return this.http.get<any>(this.URLAddress('/delete/examCalendar?id=' + id));
  }

  // Exam Master API Methods
  listExamMaster(entity, session): Observable<any> {
    return this.http.get<any>(this.URLAddress('/list/examMaster?entity=' + entity + '&session=' + session));
  }

  listExamMasterWithFilters(queryParams: string): Observable<any> {
    return this.http.get<any>(this.URLAddress('/list/examMaster?' + queryParams));
  }

  listExamMasterWithFiltersPost(payload: any, queryParams: string = ''): Observable<any> {
    let url = '/list/examMaster';
    if (queryParams) {
      url += '?' + queryParams;
    }
    return this.http.post<any>(this.URLAddress(url), payload);
  }

  addExamMaster(formData): Observable<any> {
    return this.http.post<any>(this.URLAddress('/add/examMaster'), formData);
  }

  viewExamMaster(id): Observable<any> {
    return this.http.get<any>(this.URLAddress('/view/examMaster?id=' + id));
  }

  editExamMaster(formData): Observable<any> {
    return this.http.post<any>(this.URLAddress('/edit/examMaster'), formData);
  }

  editReEvaluationExamMaster(formData): Observable<any> {
    return this.http.post<any>(this.URLAddress('/editReEvaluation/examMaster'), formData);
  }

  saveReEvaluationMarks(formData): Observable<any> {
    return this.http.post<any>(this.URLAddress('/saveReEvaluationMarks/examRegistration'), formData);
  }

  deleteExamMaster(id): Observable<any> {
    return this.http.get<any>(this.URLAddress('/delete/examMaster?id=' + id));
  }

  copyFromSessionExamMaster(queryParams: string, payload?: any): Observable<any> {
    if (payload) {
      return this.http.post<any>(this.URLAddress('/copyFromSession/examMaster?' + queryParams), payload);
    }
    return this.http.get<any>(this.URLAddress('/copyFromSession/examMaster?' + queryParams));
  }

  listSubjectCourseMapping(queryParams: string): Observable<any> {
    return this.http.get<any>(this.service.URLAddress('/list/subjectCourseMapping?' + queryParams, 'academic'));
  }

  // COE Validation API Methods (used by COE Exam Registration)
  checkStudentDues(studentId): Observable<any> {
    return this.http.get<any>(this.URLAddress('/checkDues/student?id=' + studentId));
  }

  checkDueWithInstallment(payload): Observable<any> {
    return this.http.post<any>(this.URLAddress('/checkDueWithInstallment/student'), payload);
  }

  getStudentAttendanceValueNew(formData): Observable<any> {
    return this.http.post<any>(this.URLAddress('/studentSummary/studentAttendanceNew'), formData);
  }

  checkIssuedRecordsCount(studentId): Observable<any> {
    return this.http.get<any>(this.URLAddress('/checkIssuedRecordsCount/libraryBook?id=' + studentId));
  }

  getStudentFeedbackCount(entityId, session, studentDetailsId): Observable<any> {
    return this.http.get<any>(
      this.URLAddress(`/getStudentFeedbackCount/studentTimeline?entity=${entityId}&session=${session}&studentDetailsId=${studentDetailsId}`)
    );
  }

  getResponseCount(entityId, session, studentDetailsId): Observable<any> {
    return this.http.get<any>(
      this.URLAddress(`/getResponseCount/feedbackFromStudentResponse?entity=${entityId}&session=${session}&studentDetailsId=${studentDetailsId}`)
    );
  }

  calculateFine(payload): Observable<any> {
    return this.http.post<any>(this.URLAddress('/calculateFine/coeTransaction'), payload);
  }
  calculateRegistrationAmount(payload): Observable<any> {
    return this.http.post<any>(this.URLAddress('/calculateRegistrationAmount/coeTransaction'), payload);
  }

  calculateReEvaluationFine(payload): Observable<any> {
    return this.http.post<any>(this.URLAddress('/calculateReEvaluationFine/coeTransaction'), payload);
  }

  saveCOETransaction(payload):Observable<UserData>{
    return this.http.post<UserData>(this.URLAddress('/saveTransaction/coeTransaction'), payload);
  }

  listCOETransaction(payload):Observable<UserData>{
    return this.http.post<UserData>(this.URLAddress('/list/coeTransaction'), payload);
  }

  viewCOETransaction(id): Observable<UserData> {
    return this.http.get<UserData>(this.URLAddress('/view/coeTransaction?id=' + id));
  }

  cancelCoeTransaction(payload): Observable<any> {
    return this.http.post<any>(this.URLAddress('/cancel/coeTransaction'), payload);
  }

  deleteCoeTransaction(id, payload?): Observable<any> {
    return this.http.post<any>(this.URLAddress('/delete/coeTransaction?id=' + id), payload || { _id: id });
  }

  passColour() {
    return localStorage.getItem('primaryColour');
  }

  getMultipleSubjectsByCourse(entityId, session, course, stream, batch, section): Observable<UserData> {
    let queryParams = 'entity='+ entityId+'&session='+session;
    if(course){
      queryParams = queryParams + '&course='+encodeURIComponent(course);
    }
    if(stream){
      queryParams = queryParams + '&stream='+stream;
    }
    if(batch){
      queryParams = queryParams + '&batch='+batch;
    }
    if(section){
      queryParams = queryParams + '&section='+section;
    }
    return this.http.get<UserData>(this.URLAddress('/getMultipleSubjectsByCourse/subjectCourseMapping?'+queryParams));
  }

  // Exam Shift Master API Methods
  listExamShiftMaster(entity): Observable<any> {
    return this.http.get<any>(this.URLAddress('/list/examShiftMaster?entity=' + entity));
  }

  addExamShiftMaster(formData): Observable<any> {
    return this.http.post<any>(this.URLAddress('/add/examShiftMaster'), formData);
  }

  viewExamShiftMaster(id): Observable<any> {
    return this.http.get<any>(this.URLAddress('/view/examShiftMaster?id=' + id));
  }

  editExamShiftMaster(formData): Observable<any> {
    return this.http.post<any>(this.URLAddress('/edit/examShiftMaster'), formData);
  }

  deleteExamShiftMaster(id): Observable<any> {
    return this.http.get<any>(this.URLAddress('/delete/examShiftMaster?id=' + id));
  }
  viewStudentWiseExamRegistration(id,examCalendar): Observable<any> {
    return this.http.get<any>(this.URLAddress('/viewStudentWiseExamRegistration/examRegistration?id=' + id + '&examCalendar='+examCalendar));
  }
  
  saveExamAttendance(formData): Observable<any> {
    return this.http.post<any>(this.URLAddress('/saveExamAttendance/examRegistration'), formData);
  }

  examRegistrationAdmitCard(payload): Observable<any> {
    return this.http.post<any>(this.URLAddress('/admitCard/examRegistration'), payload);
  }

  dailyMonitoringExamMaster(payload): Observable<any> {
    return this.http.post<any>(this.URLAddress('/dailyMonitoring/examMaster'), payload);
  }

  listAssessmentGradeSetup(entityId, session): Observable<UserData[]> {
    return this.http.get<UserData[]>(this.URLAddress('/list/assessmentGradeSetup?entity=' + entityId + '&session=' + session));
  }

  // COE Bundle API Methods
  addCOEBundle(formData): Observable<any> {
    return this.http.post<any>(this.URLAddress('/add/coeBundle'), formData);
  }

  listCOEBundle(queryParams: string): Observable<any> {
    return this.http.get<any>(this.URLAddress('/list/coeBundle?' + queryParams));
  }

  viewCOEBundle(id): Observable<any> {
    return this.http.get<any>(this.URLAddress('/view/coeBundle?id=' + id));
  }

  editCOEBundle(formData): Observable<any> {
    return this.http.post<any>(this.URLAddress('/edit/coeBundle'), formData);
  }

  getBundleExamRegistration(queryParams: string): Observable<any> {
    return this.http.get<any>(this.URLAddress('/getBundle/examRegistration?' + queryParams));
  }

  createPracticalBundles(payload): Observable<any> {
    return this.http.post<any>(this.URLAddress('/createPracticalBundles/examRegistration'), payload);
  }

  getBundleWithRegNo(queryParams: string): Observable<any> {
    return this.http.get<any>(this.URLAddress('/getBundleWithRegNo/examRegistration?' + queryParams));
  }

  dailyEvaluationReport(payload): Observable<any> {
    return this.http.post<any>(this.URLAddress('/dailyEvaluationReport/examRegistration'), payload);
  }

  listExamRegistrationByBundle(entity, session, bundleId): Observable<any> {
    let queryParams = `entity=${entity}&session=${encodeURIComponent(session || '')}`;
    if (bundleId) {
      queryParams += `&bundleId=${bundleId}`;
    }
    return this.http.get<any>(this.URLAddress('/list/examRegistration?' + queryParams));
  }

  viewSubjectWiseMapping(queryParams: string): Observable<any> {
    return this.http.get<any>(this.URLAddress('/viewSubjectWiseMapping/questionCOMapping?' + queryParams));
  }

  // Question CO Mapping
  addQuestionCOMapping(payload): Observable<any> {
    return this.http.post<any>(this.URLAddress('/add/questionCOMapping'), payload);
  }

  getQuestionCOMappingList(examCalendar, entity, session): Observable<any> {
    let queryParams = 'entity=' + entity + '&session=' + session;
    if (examCalendar) {
      queryParams += '&examCalendar=' + examCalendar;
    }
    return this.http.get<any>(this.URLAddress('/list/questionCOMapping?' + queryParams));
  }

  viewQuestionCOMapping(id): Observable<any> {
    return this.http.get<any>(this.URLAddress('/view/questionCOMapping?id=' + id));
  }

  editQuestionCOMapping(payload): Observable<any> {
    return this.http.post<any>(this.URLAddress('/edit/questionCOMapping'), payload);
  }

  deleteQuestionCOMapping(id): Observable<any> {
    return this.http.get<any>(this.URLAddress('/delete/questionCOMapping?id=' + id));
  }
  deleteManyExamRegistrations(payload): Observable<any> {
    return this.http.post<any>(this.URLAddress('/deleteMultiple/examRegistration'), payload);
  }

  deleteExamRegistration(id): Observable<any> {
    return this.http.get<any>(this.URLAddress('/delete/examRegistration?id=' + id));
  }
  
  deleteCoeBundle(id): Observable<any> {
    return this.http.get<any>(this.URLAddress('/delete/coeBundle?id=' + id));
  }
  listExamRegistrationCOEWithAdmitCardStatus(entity,session,course,stream,batch, examType, subjectCode,admitCardStatus,attendanceValue = '',examCalendar?):Observable<UserData[]>{
      let queryParams =entity
      if(session)
      {
        queryParams+='&session='+session
      }
      if(course)
      {
        queryParams+='&course='+course
      }
      if(stream)
        {
          queryParams+='&stream='+stream
        }
        if(batch)
          {
            queryParams+='&batch='+batch
          }
          if(examType){
            queryParams+='&examType='+examType
          }
          if(subjectCode){
            queryParams+='&subjectCode='+subjectCode
          }
          if(admitCardStatus){
            queryParams+='&admitCardStatus='+admitCardStatus
          }
          if(attendanceValue){
            queryParams+='&attendanceValue='+attendanceValue
          }
          if(examCalendar)
          {
            queryParams+='&examCalendar='+examCalendar
          }
      return this.http.get<UserData[]>(this.URLAddress('/list/examRegistration?entity='+queryParams))
    }
  listExamAttendanceList(entity,session, examType, subjectCode,admitCardStatus,examDate,examCalendar):Observable<UserData[]>{
      let queryParams =entity+'&session='+session
      let formData = {
        subjects : subjectCode
      }
          if(examType){
            queryParams+='&examType='+examType
          }
          if(admitCardStatus){
            queryParams+='&admitCardStatus='+admitCardStatus
          }
          if(examDate)
          {
            queryParams +='&examDate='+examDate
          }
          if(examCalendar)
          {
            queryParams+='&examCalendar='+examCalendar
          }
      return this.http.post<UserData[]>(this.URLAddress('/list/examRegistration?entity='+queryParams),formData)
    }

    uploadExamRegistrationExcel(entityId, session, fileData): Observable<any>{
      return this.http.post<any>(this.URLAddress('/uploadSheet/examRegistration?entity=' +entityId+'&session='+session), fileData)
    }

    updateExamRegistrationExcel(entityId, session, fileData): Observable<any>{
      return this.http.post<any>(this.URLAddress('/updateSheet/examRegistration?entity=' +entityId+'&session='+session), fileData)
    }

    getMarksByMaskingId(entityId, session, bundleId): Observable<any>{
      return this.http.get<any>(this.URLAddress('/getMarksByMaskingId/examRegistration?entity=' +entityId+'&session='+session+'&bundleId='+bundleId))
    }

  getMarksByMaskingNumber(entityId, session, maskingNumber): Observable<any>{
    return this.http.get<any>(this.URLAddress('/getMarksByMaskingId/examRegistration?entity=' + entityId + '&session=' + session + '&maskingNumber=' + encodeURIComponent(maskingNumber)))
  }

  listExamRegistrationByMaskingNumber(entityId, session, maskingNumber): Observable<any> {
    const queryParams =
      'entity=' + encodeURIComponent(entityId || '') +
      '&session=' + encodeURIComponent(session || '') +
      '&maskingNumber=' + encodeURIComponent(maskingNumber || '');
    return this.http.get<any>(this.URLAddress('/list/examRegistration?' + queryParams));
  }

    getMarksByRegNo(entityId, session, bundleId): Observable<any>{
      return this.http.get<any>(this.URLAddress('/getMarksByRegNo/examRegistration?entity=' +entityId+'&session='+session+'&bundleId='+bundleId))
    }

    editExamRegistration(formData): Observable<any>{
      return this.http.post<any>(this.URLAddress('/edit/examRegistration'), formData)
    }

    updateInternalMarksAndLock(formData): Observable<any>{
      return this.http.post<any>(this.URLAddress('/updateInternalMarksAndLock/examRegistration'), formData);
    }

    getMarksEntryStudents(entityId, session, examCalendar, examType, course, stream, batch, subjectCode, section, admitCardStatus, bundleId, internalRequired?: boolean): Observable<any> {
      let queryParams = `entity=${entityId}&session=${session}`;
      if (examCalendar) queryParams += `&examCalendar=${examCalendar}`;
      if (examType) queryParams += `&examType=${examType}`;
      if (course) queryParams += `&course=${encodeURIComponent(course)}`;
      if (stream) queryParams += `&stream=${stream}`;
      if (batch) queryParams += `&batch=${batch}`;
      if (subjectCode) queryParams += `&subjectCode=${subjectCode}`;
      if (section) queryParams += `&section=${section}`;
      if (admitCardStatus) queryParams += `&admitCardStatus=${admitCardStatus}`;
      if (bundleId) queryParams += `&bundleId=${bundleId}`;
      if (internalRequired !== undefined && internalRequired !== null) queryParams += `&internalRequired=${internalRequired}`;
      return this.http.get<any>(this.URLAddress(`/getMarksByRegNo/examRegistration?${queryParams}`));
    }
    
    setBundleLockMasking(payload): Observable<any> {
      return this.http.post<any>(this.URLAddress('/setBundleLockMasking/examRegistration'), payload);
    }
    asssstantLockMarking(payload): Observable<any> {
      return this.http.post<any>(this.URLAddress('/setCheckingAssistantLockMarking/examRegistration'), payload);
    }

    getPendingExamRegistrationReport(payload): Observable<any> {
      return this.http.post<any>(this.URLAddress('/pendingExamRegistration/examRegistration'), payload);
    }

    getPendingMarksEntryReport(payload): Observable<any> {
      return this.http.post<any>(this.URLAddress('/marksReport/examRegistration'), payload);
    }

    getSubjectTypeWiseMarksReport(payload): Observable<any> {
      return this.http.post<any>(this.URLAddress('/subjectTypeWiseMarksReport/examRegistration'), payload);
    }


    getSubjectWiseMarksReport(payload): Observable<any> {
      return this.http.post<any>(this.URLAddress('/subjectMarksReport/examRegistration'), payload);
    }

    getResultAnalysisReport(payload): Observable<any> {
      return this.http.post<any>(this.URLAddress('/resultAnalysisReport/examRegistration'), payload);
    }

    getStudentDmcReport(payload): Observable<any> {
      return this.http.post<any>(this.URLAddress('/resultSheet/examRegistration'), payload);
    }

    getRevaluationResultSheet(payload): Observable<any> {
      return this.http.post<any>(this.URLAddress('/resultSheet/examRegistration'), payload);
    }

    getHodResultSheet(payload): Observable<any> {
      return this.http.post<any>(this.URLAddress('/resultSheet/examRegistration'), payload);
    }

    getCombinedResultSheet(payload): Observable<any> {
      return this.http.post<any>(this.URLAddress('/combinedResultSheet/examRegistration'), payload);
    }

    resetMaskingNumberSequence(payload): Observable<any> {
      return this.http.post<any>(this.URLAddress('/resetMaskingNumberSequence/examRegistration'), payload);
    }

    generateMaskingNumbers(payload): Observable<any> {
      return this.http.post<any>(this.URLAddress('/generateMaskingNumbers/examRegistration'), payload);
    }

    generateDmcNumbers(payload): Observable<any> {
      return this.http.post<any>(this.URLAddress('/generateDmcNumbers/examRegistration'), payload);
    }

    autoGenerateMaskingNumbers(payload): Observable<any> {
      return this.http.post<any>(this.URLAddress('/autoGenerateMaskingNumbers/examRegistration'), payload);
    }
    
    listUsers(entityId, session): Observable<UserData[]>{
      return this.http.get<UserData[]>(this.URLAddress('/list/user?entity='+entityId+ '&session=' +session))
    }
    getGraceMarksCOE(payload):Observable<UserData>{
      return this.http.post<UserData>(this.URLAddress('/getGraceMarks/examRegistration'), payload);
    }

    generateCoeStudentCertificates(payload): Observable<any> {
      return this.http.post<any>(this.URLAddress('/generateCoeStudentCertificates/examRegistration'), payload);
    }

    autoSaveGraceMarksCOE(payload): Observable<any> {
      return this.http.post<any>(this.URLAddress('/autoSaveGraceMarks/examRegistration'), payload);
    }
}
